import { useMemo } from 'react';
import { Box, BoxProps } from '@chakra-ui/react';
import { Colors, Text } from '@mercator-gcp/grout';

const containerStyle = {
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  marginTop: 'padding_16',
  marginBottom: 'padding_16',
};

const lineStyle = {
  flexGrow: 1,
  borderTop: '1px solid',
  borderColor: Colors.ArmyGreen300,
};

const textStyle = {
  marginLeft: 'padding_8',
  marginRight: 'padding_8',
};

type Props = { text: string; sx?: BoxProps['sx'] };

const SeparatorWithText = ({ text, sx = {} }: Props) => {
  const combinedStyle = useMemo(() => {
    return { ...containerStyle, ...sx };
  }, [sx]);

  return (
    <Box sx={combinedStyle}>
      <Box sx={lineStyle} />
      <Text.SmallLabel sx={textStyle}>{text}</Text.SmallLabel>
      <Box sx={lineStyle} />
    </Box>
  );
};

export default SeparatorWithText;
